var render = function render(){var _vm=this,_c=_vm._self._c;return _c('k-multiselect',{attrs:{"options":_vm.options,"plaintext":_vm.plaintext},on:{"balabala":_vm.multChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }